import React from "react";
import Home from "../features/containers/Home";
function HomePage() {
  return <Home />;
}

export default HomePage;
